function parseJwt(token: string): { exp: number } {
  const base64Url = token.split('.')[1];
  if (!base64Url) {
    return { exp: 0 };
  }

  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = atob(base64);
  return JSON.parse(jsonPayload) as { exp: number };
}

export default function validJwtToken(token?: string | null) {
  if (!token) return false;

  const { exp } = parseJwt(token);
  if (exp) {
    // check token must be valid for > 5 minutes
    const now = Date.now() + 5 * 60 * 1000;

    // exp is in seconds, so we need to multiply by 1000 to get milliseconds
    const timeLeft = exp * 1000 - now;

    // ensure there's at least 5 minutes left on the token
    return timeLeft >= 0;
  } else {
    return false;
  }
}
